var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page404"},[_c('van-empty',{attrs:{"description":"找遍全世界也没找到该页面"}}),_c('van-button',{staticClass:"back-bth",attrs:{"type":"default","plain":"","round":""},on:{"click":_vm.back}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }